import RessourceDetailDrawer from './RessourceDetailDrawer'
export default RessourceDetailDrawer